import {Container, Grid, Typography, styled} from "@mui/material";
import storiesHero from "./hero_bg.jpeg";
import { BlueBanner } from '../../Components/BlueBanner';

const StyledBlogHeader = styled(Grid)(({ theme }) => ({
    background: "radial-gradient(at 10% 100%, #375271 0%, #0F2F4B 34%) 0% 0% no-repeat",
    color: "#fff",
    "& .mainContainer": {
        paddingTop: "330px", 
        paddingBottom: "55px", 
        position: "relative",
    },
}));

export const BlogHeader = () => {
    
    return <StyledBlogHeader>
        <Grid item sx={{
            backgroundImage: 'url('+storiesHero+')',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
        }} className="heroClass">
            <Container maxWidth={"lg"}>
                <Grid container className="mainContainer">
                    <Grid item md={8} lg={6}>
                        <Grid container sx={{position: "relative", backgroundColor:"rgba(255,255,255,0.75)", padding:"40px 20px 20px", marginBottom: "40px" }}>
                            <Typography variant={"caption"} component={"div"} sx={{color: "#011E3F", textAlign: "left", zIndex: 100,  position: "relative"}}>
                                Blog
                            </Typography>
                            <Typography sx={{color: "#011E3F", margin: "30px 0 20px", textAlign: "left", fontSize: "20px"}}>
                                We are thrilled to announce the launch of a new blog series dedicated to key themes surrounding the integration of sexual and reproductive health and rights (SRHR) within the broader framework of universal health coverage (UHC).This series will serve as a valuable resource for sharing insights, research findings, and innovative approaches aimed at enhancing the quality and accessibility of sexual and reproductive health services. Our goal is to contribute to the ongoing dialogue about effectively implementing policies and programmes that prioritize SRHR within health systems globally.
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </Grid>

        <BlueBanner />
    </StyledBlogHeader>;
};

